

import { SubDomain } from "../SubDomain";
import Category from './Category.js';

export default class CategorysDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Category.MODEL_NAME);
    this.storage = storage;
  }
  
  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Category(this.domain, item);
      }
    }

    return new Category(this.domain);
  }
}